import { render, staticRenderFns } from "./SalaryGrade.vue?vue&type=template&id=c9a217e4&scoped=true&"
import script from "./SalaryGrade.vue?vue&type=script&lang=js&"
export * from "./SalaryGrade.vue?vue&type=script&lang=js&"
import style0 from "./SalaryGrade.vue?vue&type=style&index=0&id=c9a217e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a217e4",
  null
  
)

export default component.exports